/* eslint-disable spire/fenced-imports */
import { CustomEditorTemplateProps, CustomSystemListFieldDefinition } from "@eisinc/CustomFieldDefinition";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import logger from "@insite/client-framework/Logger";
import Checkbox from "@insite/mobius/Checkbox";
import Typography from "@insite/mobius/Typography";
import { ArchiveFilter, getAdminSystemListValues } from "@insite/shell/Services/AdminService";
import * as React from "react";
import { css } from "styled-components";

type Props = CustomEditorTemplateProps<string[], CustomSystemListFieldDefinition>;

interface SystemListValues {
    value: string;
    displayName: string;
}

type State = {
    options: SystemListValues[];
    selectedItems: string[];
};

export default class SystemListMultiSelectDropDownField extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            options: [],
            selectedItems: this.props.fieldValue || [],
        };

        if (!this.props.fieldDefinition.systemListName) {
            logger.error(
                `There was no systemListName defined in the properties for the fieldDefinition ${this.props.fieldDefinition.name}`,
            );
        }
    }

    async componentDidMount() {
        const options = await this.getOptions();
        this.setState({ options });
    }

    getOptions = async () => {
        const listValues = await getAdminSystemListValues({
            archiveFilter: ArchiveFilter.Active,
            $filter: `systemList/name eq '${this.props.fieldDefinition.systemListName}'`,
            $select: "name",
        });
        return listValues.map(o => ({
            value: o.name,
            displayName: o.name,
        }));
    };

    onChangeHandler = (listItem: SystemListValues, value: boolean) => {
        const newValues = value
            ? this.state.selectedItems.concat(listItem.value)
            : this.state.selectedItems.filter(item => item !== listItem.value);
        this.setState({ selectedItems: newValues });
        this.props.updateField(this.props.fieldDefinition.name, newValues);
    };

    render() {
        const { options, selectedItems } = this.state;
        return (
            <>
                <Typography
                    css={css`
                        margin: 25px 0 10px;
                        font-weight: bold;
                    `}
                    transform="uppercase"
                >
                    {this.props.fieldDefinition.displayName}
                </Typography>
                <StyledWrapper
                    css={css`
                        max-height: 200px;
                        display: flex;
                        flex-direction: column;
                        overflow: auto;
                        padding: 2px 8px;
                        background: #fff;
                        border: 1px solid lightgray;
                        border-readius: 4px;
                        margin-top: 10px;
                    `}
                >
                    {options.length > 0 &&
                        options.map(option => {
                            return (
                                <Checkbox
                                    css={css`
                                        margin-bottom: 5px;
                                    `}
                                    key={option.value}
                                    onChange={(_, value) => this.onChangeHandler(option, value)}
                                    checked={selectedItems.indexOf(option.value) > -1}
                                >
                                    {option.displayName}
                                </Checkbox>
                            );
                        })}
                </StyledWrapper>
            </>
        );
    }
}
